import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { getRewardRedemptions } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import {
  rewardRedemptionsViewColumns,
  rewardRedemptionsSearchSchema,
  mapRewardRedemptionsViewQuery,
  redemptionInitialValues,
} from "./RewardRedemptionsView.default";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface RewardRedemptionsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function RewardRedemptionsView(props: RewardRedemptionsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={rewardRedemptionsViewColumns}
      schema={rewardRedemptionsSearchSchema}
      mapQuery={mapRewardRedemptionsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getRewardRedemptions, { retry: true })}
      pageSize={100}
      initialValues={redemptionInitialValues}
      autoSearch
      actions={[
        {
          key: "manage",
          label: "Manage",
          disabled: !permissions.can("RewardRedemptions", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default RewardRedemptionsView;
